<div #featureList class="feature-container">
  <div class="header">
    <i mat-icon-button class="material-icons help-icon">help</i>
    <p>
      {{ res.get('Controls-ChoiceMenu-HeaderText-1') }}
      <br />
      {{ res.get('Controls-ChoiceMenu-HeaderText-2') }}
    </p>
    <button mat-icon-button class="cancel-button" (click)="closePopup()">
      <mat-icon [svgIcon]="res.svgName('Close-Image')"></mat-icon>
    </button>
  </div>
  <mat-divider></mat-divider>
  @for (category of selectedObjects; track category; let i = $index) {
    <div>
      <div class="item-container">
        <p>{{ category.name }}</p>
        @for (item of category.items; track item) {
          <div class="item-row">
            <p>{{ item.name }}</p>
            <div class="item-buttons">
              @for (button of item.buttons; track button) {
                <div class="badge-container">
                  @if (!button.badgeHidden && button.badgeValue) {
                    <div class="badge">
                      <p>{{ button.badgeValue }}</p>
                    </div>
                  }
                  <button (click)="onAction(item.entity, button, $event)" [class.disabled]="!button.enabled">
                    <img [src]="button.svgImage" />
                  </button>
                </div>
              }
            </div>
          </div>
        }
      </div>
      @if (i < category.items.length) {
        <mat-divider></mat-divider>
      }
    </div>
  }
</div>
